import { render, staticRenderFns } from "./card-3ds-information-form.vue?vue&type=template&id=67a5863d&"
import script from "./card-3ds-information-form.vue?vue&type=script&lang=js&"
export * from "./card-3ds-information-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports